import styled from 'styled-components'
export const CodeHighlighterLightDiv = styled.div`
pre code.hljs {
  display: block;
  overflow-x: auto;
  padding: 1em;
  white-space: 'pre-wrap'; 
  word-wrap: 'break-word';
}
code.hljs {
  padding: 3px 5px
}

.hljs {
  color: var(--text-color-primary, #000);
  font-family: monospace, 'Operator Mono','Fira Code',Consolas,Monaco,'Andale Mono','Ubuntu Mono';
  font-size: '14px';
  line-height: '25px';
  font-weight: '400';
  direction: 'ltr';
  text-align: 'left';
  white-space: 'pre';
  word-spacing: 'normal';
  word-break: 'normal';
  tab-size: '4';
  letter-spacing: '.5px';
}
/* Comment */
.hljs-comment,
.hljs-quote {
  color: #8d8687
}
/* Red */
.hljs-variable,
.hljs-template-variable,
.hljs-tag,
.hljs-name,
.hljs-selector-id,
.hljs-selector-class,
.hljs-regexp,
.hljs-link,
.hljs-literal,
.hljs-number,
.hljs-meta {
  color: #ff628c
}
/* Orange */
.hljs-built_in,
.hljs-type,
.hljs-params,
.hljs-deletion {
  color: #ff7f00
}
/* Yellow */
.hljs-title,
.hljs-section,
.hljs-attribute {
  color: #ffb454
}
/* Green */
.hljs-string,
.hljs-symbol,
.hljs-bullet,
.hljs-addition {
  color: #47b15d
}
.hljs-keyword,
.hljs-selector-tag {
  color: #ff7f00
}
.hljs-emphasis {
  font-style: italic
}
.hljs-strong {
  font-weight: bold
}
`
